import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxMaskDirective } from 'ngx-mask';
import Swal from 'sweetalert2';
import { RestClientService } from '../../../../core/service/rest-client.service';
import { AuthService } from '../../../../core/service/auth.service';
import { UtilitiesService } from '../../../../core/service/utilities.service';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from '@danielmoncada/angular-datetime-picker';
import { BenefInfoComponent } from '@shared/components/benef-info/benef-info.component';
import { FileUploadComponent } from '@shared/components/file-upload/file-upload.component';
import { ScrollSearchMedocPrestaComponent } from '@shared/components/scroll-search-medoc-presta/scroll-search-medoc-presta.component';
import { PrestationInfoComponent } from '@shared/components/prestation-info/prestation-info.component';
import { SearchMdicamentProComponent } from '@shared/components/search-mdicament-pro/search-mdicament-pro.component';
import { SearchExamenLaboComponent } from '@shared/components/search-examen-labo/search-examen-labo.component';
import { SearchFormComponent } from "@shared/components/search-form/search-form.component";
import { SearchExamenRadioComponent } from "@shared/components/search-examen-radio/search-examen-radio.component";
import { MoneyFormatPipe } from '../../../../shared/pipe/money-format.pipe';
import { ScrollSearchActeComponent } from "@shared/components/scroll-search-acte/scroll-search-acte.component";

@Component({
  selector: 'app-form-pres-dentisterie',
  standalone: true,
  imports: [CommonModule, NgSelectModule, FormsModule,
    MatFormFieldModule, MatInputModule, MatSelectModule, MatOptionModule,
    ReactiveFormsModule, MatIconModule,
    MatCheckboxModule, MatRadioModule, MatDatepickerModule, MatButtonModule,
    OwlDateTimeModule, OwlNativeDateTimeModule, MatSlideToggleModule,
    SearchExamenRadioComponent, SearchFormComponent, MoneyFormatPipe],
  templateUrl: './form-pres-dentisterie.component.html',
  styleUrl: './form-pres-dentisterie.component.css',
})
export class FormPresDentisterieComponent implements OnInit {
selectedTab = 'tab1';
  @Output() onSendBenefItem = new EventEmitter<any>();
  @Output() onClosePrescriptionMedocModal = new EventEmitter<any>();
  @Output() onGoToTab = new EventEmitter<any>();
  @Output() onPrescriptionSaved = new EventEmitter<void>();
  @Input() matricule: any
  @Input() praticienId: any
  cancelItemSelected = false
  @Input() refreshTriggerOrdonnance!: boolean;

  current_medicament_id: any = ''
  reload = false
  produit: string = '';
  clearText = false
  posologie: string = '';
  frequence: string = '';
  renouvellement: string = '';
  quantite: number = 1;
  items: any = []
  selectedItem: any = {}
  dossierActif: any = {}
  prestationActive: any = {}
  itemsElement: any = []


  isLoading: boolean | undefined;
  input_value: any;
  input_option = 'MAT';
  searchPlaceHolder = 'Entrez numéro matricule'

  user: any = {};
  isConsultationSuccess = false;
  itemConsultation: any = {};
  itemToAdd: any = {}
  itemToSave: any = {}
  itemsModePrescription = [{ code: 'produit', libelle: 'Produit' }, { code: 'molecule', libelle: 'Molécule' }]
  // model: NgbDateStruct | undefined;
  itemBeneficiare: any = {};
  fileName1: any;
  currentFile: any;
  selectedConsultationDentaire: any = []
  itemsAffection: any;
  itemsConsultationDentaire: any;
  selectedPrescription: any;
  beneficiaireAutOselect: any;
  itemsGarantie: any;
  itemsPraticien: any[] = [];

  // Tooth chart
  teethQ1 = ['18','17','16','15','14','13','12','11'];
  teethQ2 = ['21','22','23','24','25','26','27','28'];
  teethQ3 = ['31','32','33','34','35','36','37','38'];
  teethQ4 = ['48','47','46','45','44','43','42','41'];
  selectedTeeth: string[] = [];

  itemsActe: any[] = [];
  loadingActes = false;
  loadingTarif = false;
  selectedActeItem: any = null;

  // Current active tab
  currentTab: number = 0;
  garantie_id: any;

  // Form data model
  // itemToSave = {
  //   // Œil Droit
  //   oeil_droit_sph: '',
  //   oeil_droit_cyl: '',
  //   oeil_droit_axe: '',
  //   oeil_droit_add: '',

  //   // Œil Gauche
  //   oeil_gauche_sph: '',
  //   oeil_gauche_cyl: '',
  //   oeil_gauche_axe: '',
  //   oeil_gauche_add: '',

  //   // Distance
  //   distance_interpupillaire: '',

  //   // Type
  //   type_double_foyer: false,
  //   type_progressif: false,

  //   // Traitement
  //   traitement_teinte: false,
  //   traitement_antireflet: false,

  //   // Filtres
  //   filtre_photocromique: false,
  //   filtre_anti_uv: false,
  //   filtre_transition: false,
  //   filtre_antibuee: false,
  //   filtre_bleu: false
  // };
  constructor(
    private restClient: RestClientService,
    private router: Router,
    private authService: AuthService,
    private utilities: UtilitiesService
  ) {
    this.user = this.authService.getCurrentUser();
    console.log('connected user: ', this.user);
    this.itemToAdd = {}
    this.itemToSave.mode_prescription = 'produit'
    // this.getItemsAffection()
    // this.itemToSave.date_prescription = {
    //   year: new Date().getFullYear(),
    //   month: new Date().getMonth() + 1, // getMonth() returns 0-11
    //   day: new Date().getDate()
    // };
    // let activeBeneficiaire = this.authService.getActiveBeneficiaire()
    // if (activeBeneficiaire.matricule) {
    //   this.searcheBenef(activeBeneficiaire.matricule)
    // }
    this.beneficiaireAutOselect = this.authService.getActiveBeneficiaire()
    this.itemToSave.douleur_niveau = 0;
    this.getItemsGarantie()
    this.getItemsPraticien()


    // Récupérer un brouillon éventuel
    // const draft = localStorage.getItem('optique_form_draft');
    // if (draft) {
    //   try {
    //     const parsedDraft = JSON.parse(draft);
    //     if (confirm('Un brouillon de prescription a été trouvé. Voulez-vous le restaurer ?')) {
    //       this.itemToSave = { ...this.itemToSave, ...parsedDraft };
    //     }
    //   } catch (error) {
    //     console.error('Erreur lors de la récupération du brouillon:', error);
    //   }
    // }


  }

  getItemsAffection() {
    let request = {
      index: 0,
      size: 1000,
      data: {},
    };

    this.restClient.post('affection/getByCriteria', request).subscribe(
      (res: any) => {
        this.isLoading = false;
        if (res && !res['hasError'] && res['items']) {
          this.itemsAffection = res.items;
          console.log('this.itemsAffection: ', this.itemsAffection);
        } else {
          this.utilities.showSweetNotification(
            res['status']['message'],
            'error'
          );
          this.itemsAffection = [];
        }
      },
      (error) => {
        this.utilities.showSweetNotification(error, 'error');
        this.itemsAffection = [];
      }
    );
  }


  onSelectTab(tab: string) {
    this.selectedTab = tab;
  }

  onChangeInputMode() {
    this.input_value = '';
    this.searchPlaceHolder = this.input_option == 'MAT' ? 'Entrez numéro matricule' : 'Entrez numéro cnam'
  }

  searcheBenef(activeBenefMatricule?: any) {
    this.itemsConsultationDentaire = []
    if (!this.input_value && activeBenefMatricule) {
      this.input_value = activeBenefMatricule
    }
    this.isLoading = false;
    this.isConsultationSuccess = false;
    let mat_form = {
      matricule: this.input_value,
    };

    this.itemBeneficiare = {};
    this.itemConsultation = {};

    let cmu_form = {
      numero_cnam: this.input_value,
    };
    if (!this.input_value) {
      const messages: { [key: string]: string } = {
        CMU: 'Veuillez reseigner numéro CMU',
        MAT: 'Veuillez reseigner numéro matricule',
      };

      const message = messages[this.input_option];

      if (message) {
        this.utilities.showSweetNotification(message, 'error');
        this.isLoading = false;
        return;
      }
    }

    let request = {
      // user_id:this.user.id,
      is_required_dossier: true,
      data: this.input_option == 'CMU' ? cmu_form : mat_form,
    };

    this.isLoading = true;

    this.restClient.post('beneficiaire/search', request).subscribe(
      (res: any) => {
        this.isLoading = false;
        if (res && !res['hasError']) {
          this.itemBeneficiare = res.item;
          this.authService.setActiveBeneficiaire(res.item)
          this.onSendBenefItem.emit(this.itemBeneficiare)
          this.getItemsConsultationDentaireActive()
          this.dossierActif = res.item.dossier_actif
          this.prestationActive = res.item.prestation_active

        } else {
          this.utilities.showSweetNotification(
            res['status']['message'],
            'error'
          );
          this.itemBeneficiare = {};
        }
      },
      (error) => {
        this.isLoading = false;
        this.utilities.showSweetNotification(error, 'error');
        this.itemBeneficiare = {};
      }
    );
  }
  getItemsConsultationDentaireActive() {
    if (!this.itemsGarantie || !this.itemsGarantie.length)
      return
    // let garantie_id = this.itemsGarantie.find((ig: any) => ig.codification == 'CONS')?.id ?? null;
    // if (!garantie_id)
    //   return
    if (!this.itemBeneficiare.id)
      return

    this.selectedConsultationDentaire = {}
    let request = {
      index: 0,
      size: 1000,
      type_prescription: 'DEN',
      data: {
        // garantie_id: garantie_id,
        matricule: this.itemBeneficiare.matricule,
        beneficiaire_id: this.itemBeneficiare.id,
        // prestataire_id: this.user.prestataire_id,
        is_factured: 0
      },
    };

    this.restClient.post('consultationDentaire/getByCriteria', request).subscribe(
      (res: any) => {
        this.isLoading = false;
        if (res && !res['hasError'] && res['items']) {
          this.itemsConsultationDentaire = res.items;
          console.log('this.itemsConsultationDentaire: ', this.itemsConsultationDentaire);
          this.itemsConsultationDentaire = this.itemsConsultationDentaire.filter((it: any) => it.count_cons_den_non_hospit == 0 && !it.is_expired && !it.is_factured );
          if (this.itemsConsultationDentaire && this.itemsConsultationDentaire.length) {
            this.itemsConsultationDentaire.map((ip: any) => {
              ip.is_active = false
            })
          }

        } else {
          this.utilities.showSweetNotification(
            res['status']['message'],
            'error'
          );
          this.itemsConsultationDentaire = [];
        }
      },
      (error) => {
        this.utilities.showSweetNotification(error, 'error');
        this.itemsConsultationDentaire = [];
      }
    );
  }




  uploadFile(event: any) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const file = event.target.files[0];
      const fileName = file.name.split('.')[0];
      const Tabextension = file.name.split('.');
      const extension = Tabextension[Tabextension.length - 1];

      console.info('fileName', fileName);
      console.info('extension', extension);
      this.fileName1 = fileName + '.' + extension;
      reader.onload = (readerEvent) => {
        const data = (readerEvent.target as any).result;
        // this.imageDisplay = data;
        const fileBase64 = data.split(',')[1];
        this.currentFile = {
          fileBase64: fileBase64,
          fileName: fileName,
          extension: extension,
          typeDocument: 'custom type',
        };
      };
    }

    reader.readAsDataURL(event.target.files[0]);
  }

  onGetDossiers() { }

  generateUniqueString() {
    // Get current timestamp in milliseconds
    var timestamp = new Date().getTime();

    // Generate a random number
    var randomNumber = Math.floor(Math.random() * 1000000); // Adjust range as needed

    // Concatenate timestamp and random number
    var uniqueString = timestamp.toString() + randomNumber.toString();

    return uniqueString;
  }


  confirmSaveItem(data: any) {
    if (!this.itemToSave.affection_id) {
      this.utilities.showSweetNotification("Veuillez sélectionner une affection / diagnostic", 'error');
      return;
    }
    if (!this.itemToSave.praticien_id) {
      this.utilities.showSweetNotification("Veuillez sélectionner un praticien", 'error');
      return;
    }

    const consultationSansDiagnostic = this.itemsElement.find((ie: any) => ie.is_consultation && !ie.diagnostic?.trim());
    if (consultationSansDiagnostic) {
      this.utilities.showSweetNotification(`Veuillez renseigner le diagnostic pour : ${consultationSansDiagnostic.acte_libelle}`, 'error');
      return;
    }

    Swal.fire({
      title: "Prescription dentaire",
      text: 'Souhaitez-vous poursuivre cette action?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0665aa',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui',
      cancelButtonText: 'Non',
    }).then((result) => {
      if (result.value) {
        this.saveItems()
      }
    });
  }

  saveItems() {
    this.isConsultationSuccess = false;

    let file_data = '';
    if (this.currentFile && Object.keys(this.currentFile).length) {
      file_data = this.currentFile;
    }
    // let copy = { ...this.itemToSave }
    // delete copy.date_prescription


    if (this.itemsElement && this.itemsElement.length) {
      this.itemsElement.map((im: any) => {
        im.affection_id = this.itemToSave.affection_id
        im.date_presription = this.itemToSave.date_presription
        im.mode_prescription = this.itemToSave.mode_prescription,
          im.matricule = this.itemBeneficiare.matricule,
          im.beneficiaire_id = this.itemBeneficiare.id,
          im.affection_id = this.itemToSave.affection_id
        im.prestation_acte_id = this.selectedConsultationDentaire.prestation_acte_id
        im.consultation_dentaire_id = this.selectedConsultationDentaire.id
        im.dossier_id = this.selectedConsultationDentaire.dossier_id
        im.zone_affectee = im.dents_concernees || ''
        im.diagnostic = im.diagnostic || ''
        im.garantie_id = this.itemsGarantie.find((itg: any) => itg.codification == 'DEN').id
        im.observation = this.itemToSave.observation
        im.prestataire_id = this.user.prestataire_id
        im.praticien_id = this.itemToSave.praticien_id
        im.is_entente_prealable = true
      }

      )
    }

    if (this.currentFile && Object.keys(this.currentFile).length) {
      this.itemConsultation.file_data = this.currentFile;
    }

    let request = {
      file_data: this.currentFile && Object.keys(this.currentFile).length ? this.currentFile : '',
      datas: [...this.itemsElement],
    };
    request.datas.forEach((d: any) => { d.prestataire_id = this.user.prestataire_id; });

    this.restClient.post('prescriptionActe/create', request).subscribe(
      (res: any) => {
        // this.isLoading = false;
        if (res && !res['hasError']) {
          this.isConsultationSuccess = true;
          this.utilities.showSweetNotification(
            res['status']['message'],
            'succes'
          );
          this.itemsElement = []
          // this.goNext()
          this.getItemsConsultationDentaireActive()
          this.onPrescriptionSaved.emit()
        } else {
          this.isConsultationSuccess = false;
          this.utilities.showSweetNotification(
            res['status']['message'],
            'error'
          );
        }
        this.onClosePrescriptionMedocModal.emit('hide')

      },
      (error) => {
        this.isConsultationSuccess = false;
        this.utilities.showSweetNotification(error, 'error');
      }
    );
  }

  onAddItemToList(): void {
    if (!this.selectedActeItem || !this.selectedActeItem.id) {
      this.utilities.showSweetNotification("Veuillez sélectionner un acte", 'error');
      return;
    }

    if (this.itemsElement.some((ie: any) => ie.acte_id == this.selectedActeItem.id)) {
      this.utilities.showSweetNotification("Cet acte est déjà dans la liste", 'error');
      return;
    }

    const isConsultation = this.selectedActeItem.codification === 'CD';
    const newItem = {
      is_entente_prealable: this.selectedActeItem.is_entente_prealable,
      is_exclu: this.selectedActeItem.is_exclu,
      acte_id: this.selectedActeItem.id,
      acte_libelle: this.selectedActeItem.libelle,
      quantite: 1,
      garantie_id: this.selectedActeItem.garantie_id,
      is_referred: this.selectedActeItem.is_referred,
      is_consultation: isConsultation,
      dents_concernees: '',
      diagnostic: '',
      montant: 0,
      part_patient: 0,
      part_assurance: 0,
    };
    this.getTarifActe(newItem);
    setTimeout(() => { this.selectedActeItem = null; }, 0);
  }

  getTarifActe(item: any): void {
    const request = {
      index: 0,
      size: 1000,
      data: {
        acte_id: item.acte_id,
        matricule: this.itemBeneficiare?.matricule || this.matricule,
        prestataire_codification: this.user?.prestataire_codification,
      },
    };
    this.loadingTarif = true;
    this.restClient.post('bareme/getTarifActeOnly', request).subscribe(
      (res: any) => {
        this.loadingTarif = false;
        if (res && !res['hasError'] && res['item']) {
          const t = res.item;
          item.montant_unitaire = t.montant;
          item.part_patient_unitaire = t.part_patient_net;
          item.part_assurance_unitaire = t.part_assurance_net;
          item.montant = t.montant;
          item.part_patient = t.part_patient_net;
          item.part_assurance = t.part_assurance_net;
          item.taux_applicable = t.taux_applicable;
          item.prestation_acte_id = t.prestation_acte_id;
          item.message_explicatif = t.message_explicatif;
          item.message_depassement = t.message_depassement;
          this.itemsElement.unshift(item);
        } else {
          this.utilities.showSweetNotification(res['status']['message'], 'error');
        }
      },
      (error) => { this.loadingTarif = false; this.utilities.showSweetNotification(error, 'error'); }
    );
  }

  onSelectRow(item: any): void {
    // if (this.isExpired(item.date_expiration)) return;
    this.selectedConsultationDentaire = { ...item }
    if (item.is_expired) return;

    this.itemsConsultationDentaire.forEach((p: any) => p.is_active = false);
    item.is_active = true;
    console.log('Selected prescription: ', item);
  }


  onSelectActe(event: any) {
    console.log('current medoc', event)
    this.selectedItem = event || {}
    console.log("selectedItem: ",this.selectedItem)
    // getTarifActe()
    // this.onAddItemToList()
  }

  isExpired(expirationDate: string | Date): boolean {
    if (!expirationDate) return false; // Handle cases with no expiration date

    const expDate = new Date(expirationDate);
    const today = new Date();

    // Compare dates (ignoring time)
    return expDate.setHours(0, 0, 0, 0) > today.setHours(0, 0, 0, 0);
  }

  toggleTooth(t: string) {
    const idx = this.selectedTeeth.indexOf(t);
    if (idx >= 0) {
      this.selectedTeeth.splice(idx, 1);
    } else {
      this.selectedTeeth.push(t);
    }
    this.itemToSave.zone_affectee = this.selectedTeeth.join(', ');
  }

  isToothSelected(t: string): boolean {
    return this.selectedTeeth.includes(t);
  }

  toggleToothForItem(item: any, tooth: string) {
    const teeth: string[] = item.dents_concernees
      ? item.dents_concernees.split(', ').filter((t: string) => t)
      : [];
    const idx = teeth.indexOf(tooth);
    if (idx >= 0) { teeth.splice(idx, 1); } else { teeth.push(tooth); }
    item.dents_concernees = teeth.join(', ');
    this.updateItemMontants(item);
  }

  updateItemMontants(item: any) {
    const count = item.dents_concernees
      ? item.dents_concernees.split(', ').filter((t: string) => t).length
      : 0;
    const qty = count || 1;
    item.montant = (item.montant_unitaire || 0) * qty;
    item.part_patient = (item.part_patient_unitaire || 0) * qty;
    item.part_assurance = (item.part_assurance_unitaire || 0) * qty;
    item.quantite = qty;
  }

  isToothSelectedForItem(item: any, tooth: string): boolean {
    if (!item.dents_concernees) return false;
    return item.dents_concernees.split(', ').includes(tooth);
  }

  clearTeeth() {
    this.selectedTeeth = [];
    this.itemToSave.zone_affectee = '';
  }

  // ── Tooth modal ──
  toothModalItem: any = null;

  openToothModal(item: any) { this.toothModalItem = item; }
  closeToothModal() { this.toothModalItem = null; }

  countTeeth(item: any): number {
    if (!item.dents_concernees) return 0;
    return item.dents_concernees.split(', ').filter((t: string) => t).length;
  }

  clearTeethForItem(item: any) {
    item.dents_concernees = '';
    this.updateItemMontants(item);
  }

  getDouleurClass(): string {
    const n = Number(this.itemToSave.douleur_niveau ?? 0);
    if (n <= 3) return 'douleur-low';
    if (n <= 6) return 'douleur-mid';
    return 'douleur-high';
  }

  ngOnInit() {
    this.getItemsAffection();
    if (this.matricule) {
      this.input_value = this.matricule;
      this.searcheBenef(this.matricule);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['matricule'] && this.matricule) {
      this.input_value = this.matricule;
      this.searcheBenef();
    }
    if (changes['refreshTriggerOrdonnance'] && changes['refreshTriggerOrdonnance'].currentValue) {
      console.log('Triggered refreshTriggerOrdonnance')
      let activeBeneficiaire = this.authService.getActiveBeneficiaire()
      console.log('activeBeneficiaire.matricule in ngOnChanges ordonnance: ', activeBeneficiaire.matricule)
      if (activeBeneficiaire.matricule) {
        this.input_value = activeBeneficiaire.matricule
        this.searcheBenef(activeBeneficiaire.matricule)
      }
    }


  }

  onSelectMedoc(event: any) {
    console.log('current medoc', event)
    this.selectedItem = event || {}
  }
  onSelectMedocPro(event: any) {
    console.log('current medoc', event)
    this.selectedItem = event || {}
    // getTarifActe()
    this.onAddItemToList()
  }

  goNext() {
    this.onGoToTab.emit('pharmacie')
  }

  getTotal(field: string): number {
    return (this.itemsElement || []).reduce((sum: number, item: any) => sum + (Number(item[field]) || 0), 0);
  }

  removeItem(index: number): void {
    if (confirm('Êtes-vous sûr de vouloir supprimer cet élément?')) {
      this.itemsElement.splice(index, 1);
    }
  }

  // onSetUserInfo(event:any){
  // if(event.id){
  //   this.itemBeneficiare=event
  //   this.authService.setActiveBeneficiaire(event)
  //   this.getItemsConsultationDentaireActive()
  // }

  onSetUserInfo(event: any) {
    if (event.id) {
      this.itemBeneficiare = event
      this.authService.setActiveBeneficiaire(event)
      this.itemConsultation = {}
      this.beneficiaireAutOselect = this.itemBeneficiare
      this.getItemsConsultationDentaireActive()
    }
    else {
      this.authService.setActiveBeneficiaire({})
      this.beneficiaireAutOselect = {}
    }

  }




  getItemsActe() {
    if (!this.garantie_id) return;
    this.loadingActes = true;
    this.restClient.post('acte/getByCriteria', { index: 0, size: 1000, data: { garantie_id: this.garantie_id } }).subscribe(
      (res: any) => {
        this.loadingActes = false;
        this.itemsActe = res?.items ?? [];
      },
      () => { this.loadingActes = false; }
    );
  }

  getItemsPraticien() {
    let request = { index: 0, size: 1000, data: {} };
    this.restClient.post('praticien/searchByPrestataire', request).subscribe(
      (res: any) => {
        if (res && !res['hasError'] && res['items']) {
          this.itemsPraticien = res.items.map((ip: any) => ({
            ...ip,
            full_name: `${ip.nom} ${ip.prenom} (${ip.specialite_libelle})`
          }));
          if (this.praticienId) {
            this.itemToSave.praticien_id = this.praticienId;
          } else if (this.itemsPraticien.length === 1) {
            this.itemToSave.praticien_id = this.itemsPraticien[0].id;
          }
        } else {
          this.itemsPraticien = [];
        }
      },
      () => { this.itemsPraticien = []; }
    );
  }

  getItemsGarantie() {
    let request = {
      index: 0,
      size: 1000,
      data: {},
    };

    this.restClient
      .post('garantie/getByCriteria', request)
      .subscribe(
        (res: any) => {
          this.isLoading = false;
          if (res && !res['hasError'] && res['items']) {
            this.itemsGarantie = res.items;
            console.log(
              'this.itemsGarantie: ',
              this.itemsGarantie
            );
            // this.getItemsActe()
            this.getItemsConsultationDentaireActive()
            this.garantie_id = this.itemsGarantie.find((ig: any) => ig.codification == 'DEN')?.id ?? null;
            this.getItemsActe();


            this.itemConsultation.raison_consultation_id =
              this.itemsGarantie[0].id;
          } else {
            this.utilities.showSweetNotification(
              res['status']['message'],
              'error'
            );
            this.itemsGarantie = [];
          }
        },
        (error) => {
          this.utilities.showSweetNotification(error, 'error');
          this.itemsGarantie = [];
        }
      );
  }


  /**
   * Change l'onglet actif
   */
  setTab(tab: number) {
    // Sauvegarder automatiquement en localStorage
    if (this.hasData()) {
      localStorage.setItem('optique_form_draft', JSON.stringify(this.itemToSave));
    }
    this.currentTab = tab;
  }

  /**
   * Onglet suivant
   */
  nextTab() {
    if (this.currentTab < 4) {
      this.setTab(this.currentTab + 1);
    }
  }

  /**
   * Onglet précédent
   */
  previousTab() {
    if (this.currentTab > 0) {
      this.setTab(this.currentTab - 1);
    }
  }

  /**
   * Copie les valeurs de l'œil droit vers l'œil gauche
   */
  copyRightToLeft() {
    if (confirm('Copier les valeurs de l\'œil droit vers l\'œil gauche ?')) {
      this.itemToSave.oeil_gauche_sph = this.itemToSave.oeil_droit_sph;
      this.itemToSave.oeil_gauche_cyl = this.itemToSave.oeil_droit_cyl;
      this.itemToSave.oeil_gauche_axe = this.itemToSave.oeil_droit_axe;
      this.itemToSave.oeil_gauche_add = this.itemToSave.oeil_droit_add;

      // Basculer vers l'onglet gauche
      this.setTab(1);
    }
  }

  /**
   * Copie les valeurs de l'œil gauche vers l'œil droit
   */
  copyLeftToRight() {
    if (confirm('Copier les valeurs de l\'œil gauche vers l\'œil droit ?')) {
      this.itemToSave.oeil_droit_sph = this.itemToSave.oeil_gauche_sph;
      this.itemToSave.oeil_droit_cyl = this.itemToSave.oeil_gauche_cyl;
      this.itemToSave.oeil_droit_axe = this.itemToSave.oeil_gauche_axe;
      this.itemToSave.oeil_droit_add = this.itemToSave.oeil_gauche_add;

      // Basculer vers l'onglet droit
      this.setTab(0);
    }
  }

  /**
   * Soumission du formulaire
   */
  onSubmit() {
    console.log('Données de la prescription:', this.itemToSave);

    // Validation
    if (!this.validateForm()) {
      return;
    }

    // Traitement de sauvegarde
    this.saveData();
  }

  /**
   * Validation du formulaire
   */
  private validateForm(): boolean {
    // Vérifier qu'au moins un œil a des données
    const hasOeilDroit = this.itemToSave.oeil_droit_sph ||
      this.itemToSave.oeil_droit_cyl ||
      this.itemToSave.oeil_droit_axe ||
      this.itemToSave.oeil_droit_add;

    const hasOeilGauche = this.itemToSave.oeil_gauche_sph ||
      this.itemToSave.oeil_gauche_cyl ||
      this.itemToSave.oeil_gauche_axe ||
      this.itemToSave.oeil_gauche_add;

    if (!hasOeilDroit && !hasOeilGauche) {
      // alert('Veuillez remplir au moins les données d\'un œil.');
      this.utilities.showSweetNotification('Veuillez remplir au moins les données d\'un œil.', 'error');
      this.setTab(0);
      return false;
    }

    // Validation de la distance interpupillaire si renseignée
    if (this.itemToSave.distance_interpupillaire) {
      const distance = parseFloat(this.itemToSave.distance_interpupillaire);
      if (isNaN(distance) || distance < 40 || distance > 80) {
        this.utilities.showSweetNotification('La distance interpupillaire doit être comprise entre 40 et 80 mm.', 'error');
        this.setTab(2);
        return false;
      }
    }

    return true;
  }

  /**
   * Sauvegarde des données
   */
  private saveData() {
    try {
      console.log('Sauvegarde en cours...');

      // Simulation d'un appel API
      setTimeout(() => {
        console.log('Prescription sauvegardée avec succès!');
        alert('Prescription sauvegardée avec succès!');
        this.clearDraft();
        this.resetForm();
      }, 1000);

    } catch (error) {
      console.error('Erreur lors de la sauvegarde:', error);
      alert('Erreur lors de la sauvegarde. Veuillez réessayer.');
    }
  }

  /**
   * Réinitialise le formulaire
   */
  resetForm() {
    this.itemToSave = {
      // Œil Droit
      oeil_droit_sph: '',
      oeil_droit_cyl: '',
      oeil_droit_axe: '',
      oeil_droit_add: '',

      // Œil Gauche
      oeil_gauche_sph: '',
      oeil_gauche_cyl: '',
      oeil_gauche_axe: '',
      oeil_gauche_add: '',

      // Distance
      distance_interpupillaire: '',

      // Type
      type_double_foyer: false,
      type_progressif: false,

      // Traitement
      traitement_teinte: false,
      traitement_antireflet: false,

      // Filtres
      filtre_photocromique: false,
      filtre_anti_uv: false,
      filtre_transition: false,
      filtre_antibuee: false,
      filtre_bleu: false
    };

    // Retourner au premier tab
    this.currentTab = 0;
  }

  /**
   * Vérifie si le formulaire a des données
   */
  hasData(): boolean {
    return Object.values(this.itemToSave).some(value =>
      typeof value === 'string' ? value.trim() !== '' : value === true
    );
  }

  /**
   * Nettoie le brouillon local
   */
  clearDraft() {
    localStorage.removeItem('optique_form_draft');
  }
}
